import { useEffect, useState } from 'react';
import type React from 'react';
import { ROUTES } from '../../../constants/Constants';
import useAppNavigation from '../../../hooks/useAppNavigation';
import useForgotModal from '../../../hooks/useForgotModal';
import useLoginModal from '../../../hooks/useLoginModal';
import useRegisterModal from '../../../hooks/useRegisterModal';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';

interface LoginProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Login: React.FC<LoginProps> = ({ ssrFetchedData }) => {
  const registerModal = useRegisterModal();
  const loginModal = useLoginModal();
  const forgotModal = useForgotModal();
  const { navigate, toLocalizedRoute } = useAppNavigation();
  const [onOpen, setOnOpen] = useState<boolean>();

  useEffect(() => {
    setOnOpen(true);
    loginModal.onOpen();
  }, []);

  useEffect(() => {
    if (
      onOpen &&
      !loginModal.isOpen &&
      !registerModal.isOpen &&
      !forgotModal.isOpen
    ) {
      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, [loginModal]);

  return null;
};

export default Login;
